(function () {
  var bd = document.querySelector('[data-cc9p]');
  var node = document.querySelector('[data-cc9p-data]');
  if (!bd || !node) return;
  var data; try { data = JSON.parse(node.textContent); } catch (e) { return; }
  var form = bd.closest('form');
  var root = form.closest('[data-nh-outerwear-pdp]') || document;
  var options = root.querySelector('.nh-cat__options');
  var optSelect = root.querySelector('.variant-dropdown');
  function q(s) { return document.querySelector('[data-nh-outerwear-pdp] ' + s) || document.querySelector(s); }
  var err = bd.querySelector('[data-cc9p-err]');
  function money(c) { return (Number(c || 0) / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/[  \s]/g, '') + '€'; }
  function tier() { var r = bd.querySelector('input[name="cc9p-tier"]:checked'); return r ? parseInt(r.value, 10) : 1; }
  function colors() { var out = []; for (var k = 1; k <= 3; k++) { var r = bd.querySelector('input[name="cc9p-u' + k + '"]:checked'); out.push(r ? r.value : null); } return out; }
  function syncUnits() {
    colors().forEach(function (c, i) {
      var n = bd.querySelector('[data-cc9p-uname="' + (i + 1) + '"]'); if (n && c) n.textContent = c;
    });
    var cols = colors();
    [1, 3].forEach(function (k) { var im = bd.querySelector('[data-cc9p-img="' + k + '"]'); var c = cols[k - 1]; if (im && c && data.img[c]) im.src = data.img[c]; });
  }
  function apply() {
    var t = tier();
    bd.querySelectorAll('.cc9p__opt').forEach(function (o) { o.classList.toggle('is-on', !!o.querySelector('input[name="cc9p-tier"]:checked')); });
    if (err) err.hidden = true;
    if (t === 2) {
      if (options) options.hidden = true;
      var price = data.unit * 2, cmp = data.unit * 3;
      var current = q('.nh-cat__current'), compare = q('.nh-cat__compare'), saving = q('.nh-cat__saving'), atcPrice = q('[data-atc-price]'), atcCompare = q('[data-atc-compare]');
      if (current) current.textContent = money(price);
      if (compare) compare.textContent = money(cmp);
      if (saving) saving.textContent = 'Vous économisez ' + money(cmp - price);
      if (atcPrice) atcPrice.textContent = money(price);
      if (atcCompare) { atcCompare.textContent = money(cmp); atcCompare.hidden = false; }
      syncUnits();
    } else {
      if (options) options.hidden = false;
      if (optSelect) optSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
  bd.addEventListener('change', function (e) {
    if (e.target.name === 'cc9p-tier') { apply(); return; }
    if (e.target.getAttribute('data-unit')) syncUnits();
  });
  if (optSelect) optSelect.addEventListener('change', function () {
    if (tier() === 2) return;
    var c = optSelect.value;
    c = (data.names && data.names[c]) || c;
    for (var k = 1; k <= 3; k++) { var r = bd.querySelector('input[name="cc9p-u' + k + '"][value="' + c.replace(/"/g, '\\"') + '"]'); if (r) r.checked = true; }
    syncUnits();
  });
  function battItem(bid, qty) {
    return { id: Number(data.batt), quantity: qty, properties: { '_nh_gift': 'true', '_nh_bundle_id': bid, '_nh_gift_label': qty + ' batterie' + (qty > 1 ? 's' : '') + ' offerte' + (qty > 1 ? 's' : ''), '_nh_gift_minimum': '1', '_nh_gift_per_garment': 'true' } };
  }
  function soloPayload() {
    var idInput = form.querySelector('[name="id"]');
    var vid = idInput ? Number(idInput.value) : 0;
    if (!vid || !data.batt) return null;
    var qInput = form.querySelector('[name="quantity"]');
    var qty = Math.max(1, parseInt(qInput ? qInput.value : 1, 10) || 1);
    var bid = 'nh-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
    return [{ id: vid, quantity: qty, properties: { '_nh_bundle_id': bid, '_nh_bundle_tier': '1', '_nh_bundle_version': '2', '_nh_bundle_unit': '1' } }, battItem(bid, qty)];
  }
  function payload() {
    var cols = colors();
    if (cols.some(function (c) { return !c || !data.variants[c]; })) return null;
    if (!data.twin[cols[2]]) return null;
    var bid = 'nh-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8), items = [];
    for (var k = 0; k < 2; k++) items.push({ id: Number(data.variants[cols[k]]), quantity: 1, properties: { '_nh_bundle_id': bid, '_nh_bundle_tier': '2', '_nh_bundle_version': '2', '_nh_bundle_unit': String(k + 1) } });
    items.push({ id: Number(data.twin[cols[2]]), quantity: 1, properties: { '_nh_gift': 'true', '_nh_bundle_id': bid, '_nh_gift_label': 'Cape offerte · ' + cols[2], '_nh_gift_minimum': '2', '_nh_gift_per_garment': 'false' } });
    if (data.batt) items.push(battItem(bid, 2));
    return items;
  }
  window.CC9P_PAYLOAD = payload;
  document.addEventListener('submit', function (e) {
    if (e.target !== form) return;
    var t = tier();
    if (t !== 2 && !data.batt) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (form.dataset.cc9pSubmitting === 'true') return;
    var items = t === 2 ? payload() : soloPayload();
    if (!items) { err.hidden = false; err.textContent = t === 2 ? 'Choisissez un coloris pour chaque cape.' : 'Choisissez un coloris.'; return; }
    form.dataset.cc9pSubmitting = 'true';
    var atc = q('[data-add-to-cart]'), atcText = atc && atc.querySelector('.atc-text');
    if (atc) atc.disabled = true;
    var original = atcText ? atcText.textContent : '';
    if (atcText) atcText.textContent = t === 2 ? 'Ajout du pack…' : 'Ajout…';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (resource) {
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: resource || null, sourceId: form.id || '9heat-bundle-form', data: { source: '9heat-bundle-form', action: 'add', openDrawer: true, itemCount: t === 2 ? 2 : 1 } } }));
        if (atcText) atcText.textContent = 'Ajouté ✓';
        setTimeout(function () { if (atcText) atcText.textContent = original; }, 1600);
      })
      .catch(function (j) {
        if (atcText) atcText.textContent = original;
        err.hidden = false; err.textContent = (j && (j.description || j.message)) ? (j.description || j.message) : 'L’ajout n’a pas fonctionné. Réessayez dans un instant.';
      })
      .finally(function () { delete form.dataset.cc9pSubmitting; if (atc) atc.disabled = false; });
  }, true);
})();
